import { render, staticRenderFns } from "./DataPointDetails.vue?vue&type=template&id=f488b9fc&scoped=true&"
import script from "./DataPointDetails.vue?vue&type=script&lang=js&"
export * from "./DataPointDetails.vue?vue&type=script&lang=js&"
import style0 from "./DataPointDetails.vue?vue&type=style&index=0&id=f488b9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f488b9fc",
  null
  
)

export default component.exports